module.exports = __webpack_public_path__ + "static/img/kettle.177e9d3.png";


//////////////////
// WEBPACK FOOTER
// ./img/project-design/kettle.png
// module id = 1027
// module chunks = 1